import React, { useEffect, useState } from 'react';
import useApiStable from '../../utils/useApiStable';
import '../../styles/NewsList.css';

function NewsList() {
    const api = useApiStable();
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [readNewsIds, setReadNewsIds] = useState(() => {
        try { return new Set(JSON.parse(localStorage.getItem("readNewsIds") || "[]")); }
        catch { return new Set(); }
    });

    useEffect(() => {
        api.get('/news')
            .then(data => setNews(Array.isArray(data) ? data : []))
            .catch(err => setError(err.message || 'Fehler beim Laden der News'))
            .finally(() => setLoading(false));
    }, []); // eslint-disable-line

    const markRead = (id) => {
        setReadNewsIds(prev => {
            const next = new Set(prev);
            next.add(String(id));
            localStorage.setItem("readNewsIds", JSON.stringify([...next]));
            return next;
        });
    };

    if (loading) return <div className="news-page"><p>Lade News...</p></div>;
    if (error)   return <div className="news-page"><p className="news-error">{error}</p></div>;

    return (
        <div className="news-page">
            <h1>Vereinsnews</h1>
            {news.length === 0 ? (
                <p className="news-empty">Aktuell keine News verfügbar.</p>
            ) : (
                news.map(item => {
                    const isRead = readNewsIds.has(String(item.id));
                    return (
                        <article key={item.id} className={`news-item${isRead ? " news-item--read" : ""}`}>
                            <h2 className="news-title">{item.title}</h2>
                            <p className="news-date">
                                {new Date(item.date).toLocaleDateString('de-DE', {
                                    day: '2-digit', month: 'long', year: 'numeric'
                                })}
                            </p>
                            <p className="news-excerpt">{item.excerpt}</p>
                            <a
                                href={item.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="news-link"
                                onClick={() => markRead(item.id)}
                            >
                                Weiterlesen →
                            </a>
                        </article>
                    );
                })
            )}
        </div>
    );
}

export default NewsList;
